import React, { useState, useEffect, useRef } from 'react'

// Deps
import { connect } from 'react-redux'

// Functions
// import formatDate from 'functions/format-date';

// Partials
import { InputForm, FormInput } from 'views/shared/partials/forms'
import Btn from 'views/shared/partials/btn'

// Utils
import { openModal } from 'utils/modals';

// Services
import companyServices from 'services/company'

const mapStateToProps = (state, ownProps) => {
	return {
		mobileState: state.site.mobile,
	};
};

const ProductSearchModal = ({close, onSuccess, ...props}) => {
	const searchInput = useRef();

	const [submitting, setSubmitting] = useState(false);

	useEffect(() => {
		setTimeout(() => {
			searchInput.current.input.current.input.current.focus();
		}, 250)
	}, [])

	const submit = (formData) => {
		setSubmitting(true);
		companyServices.getERPClient(formData.erp_client_code).then((payload) => {
			if(onSuccess) {
				onSuccess(payload);
				close();
			}
			else {
				setSubmitting(false);
			}
		}).catch((e) => {
			openModal('alert', {
				message: 'Müşteri bulunamadı.',
				top: true,
			});
		});
	}
	
	return (
		<InputForm
			onSubmit={submit}
			className={props.className}>
			<div className="modal-header controls dark">
				<h1 className="header-title">ERP Müşteri Sorgula</h1>
				{props.closeBtn}
			</div>


			<div className="modal-content">
				<FormInput
					ref={searchInput}
					disabled={submitting}
					type="text"
					label="Müşteri Kodu"
					name="erp_client_code"
					placeholder="Müşteri kodunu girin."
					value="CRTQ2281UVG"
					validation={{
						required: 'Bir müşteri kodu girmelisiniz.',
						minLength: ['Müşteri kodu en az {length} karakter içermelidir.', 4]
					}} />
			</div>
			<div className="modal-controls">
				<Btn
					disabled={submitting}
					loading={submitting}
					className="flex"
					type="submit"
					icon="search"
					big>
					Ara
				</Btn>
			</div>
		</InputForm>
	)
}

const ConnectedModal = connect(mapStateToProps)(ProductSearchModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-erp-client-search',
	name: 'erp-client-search',
	title: false,
	content: false,
	source: false,
}

export default ConnectedModal